import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';


@Component({
  selector: 'flood-zone-lov',
  templateUrl: './flood-zone-lov.component.html',
  styleUrls: ['./flood-zone-lov.component.css']
})
export class FloodZoneLovComponent implements OnInit {

  private floodZoneModuleId: string = 'BMM190';
  private selectedData: any;
  public titleLov: string = "Flood Zoning".toUpperCase();

  floodZoneTable: any = {
    cols: [],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  private floodZoneTableCol: any[] = [
    {
      key: "FLOOD_ZONE_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "FLOOD_LONG_DESC",
      header: "Description",
      dataType: "string"
    },
  ];
  private floodZoneTablePlanCol: any[] = [
    {
      key: "FLOOD_ZONE_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "FLOOD_LONG_DESC",
      header: "Plan",
      dataType: "string"
    },
  ];
  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<FloodZoneLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    if("title" in this.fromMainData){
      this.titleLov = this.fromMainData.title;
    }
    if("tableData" in this.fromMainData){
      if(this.fromMainData.tableData == "PLAN"){
        this.floodZoneTable.cols = this.floodZoneTablePlanCol;
        this.getFloodZoneData();
      }
      else{
        this.floodZoneTable.cols = this.floodZoneTableCol;
        this.getFloodZoneData();
      }
    }
    else{
      this.floodZoneTable.cols = this.floodZoneTableCol;
      this.getFloodZoneData();
    }
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getFloodZoneData(): void {
    try {
      this.floodZoneTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getFloodZoning({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.floodZoneModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.floodZoneTable.tblData = content.data?.filter((e: any) => e.ACTIVE_TAG == 'A') ?? [];
                this.floodZoneTable.loading = false;
              } else {
                this.floodZoneTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.floodZoneTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.floodZoneTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
